import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  FormControlLabel,
  Switch,
} from "@mui/material";

const DriverHistoryForm = ({ driverHistory, onSubmit, onCancel, isBusy }) => {
  const [formData, setFormData] = useState({
    dateFrom: "",
    dateTo: "",
    name: "",
    description: "",
    isActive: true,
  });
  const [errors, setErrors] = useState({
    dateFrom: "",
    dateTo: "",
    name: "",
    description: "",
  });

  useEffect(() => {
    if (driverHistory) {
      setFormData({
        dateFrom: formatDate(driverHistory.dateFrom) || "",
        dateTo: formatDate(driverHistory.dateTo) || "",
        name: driverHistory.name || "",
        description: driverHistory.description || "",
        isActive: driverHistory.isActive ?? true,
      });
    }
  }, [driverHistory]);

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toISOString().split("T")[0];
  };

  const validateForm = (data) => {
    const newErrors = {
      dateFrom: "",
      dateTo: "",
      name: "",
      description: "",
    };
    let isValid = true;

    // Required field validation
    if (!data.dateFrom) {
      newErrors.dateFrom = "Date From is required";
      isValid = false;
    }
    if (!data.dateTo) {
      newErrors.dateTo = "Date To is required";
      isValid = false;
    }
    if (!data.name) {
      newErrors.name = "Name is required";
      isValid = false;
    }
    if (!data.description) {
      newErrors.description = "Description is required";
      isValid = false;
    }

    // Date range validation
    if (data.dateFrom && data.dateTo) {
      const fromDate = new Date(data.dateFrom);
      const toDate = new Date(data.dateTo);
      if (fromDate > toDate) {
        newErrors.dateFrom = "Date From cannot be later than Date To";
        newErrors.dateTo = "Date To cannot be earlier than Date From";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newFormData = { ...formData, [name]: value };
    setFormData(newFormData);
    validateForm(newFormData); // Validate on change
  };

  const handleSwitchChange = (e) => {
    const newFormData = { ...formData, isActive: e.target.checked };
    setFormData(newFormData);
    validateForm(newFormData);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm(formData)) {
      onSubmit(formData);
      setFormData({
        dateFrom: "",
        dateTo: "",
        name: "",
        description: "",
        isActive: true,
      });
      setErrors({
        dateFrom: "",
        dateTo: "",
        name: "",
        description: "",
      });
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} padding={3}>
      <Grid container spacing={2}>
        {/* Date From Field */}
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            label="Date From"
            type="date"
            name="dateFrom"
            value={formData.dateFrom}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            required
            error={!!errors.dateFrom}
            helperText={errors.dateFrom}
          />
        </Grid>

        {/* Date To Field */}
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            label="Date To"
            type="date"
            name="dateTo"
            value={formData.dateTo}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            required
            error={!!errors.dateTo}
            helperText={errors.dateTo}
          />
        </Grid>

        {/* Name Field */}
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            label="Name"
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            required
            error={!!errors.name}
            helperText={errors.name}
          />
        </Grid>

        {/* Description Field */}
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            label="Description"
            type="text"
            name="description"
            value={formData.description}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            required
            error={!!errors.description}
            helperText={errors.description}
          />
        </Grid>

        {driverHistory && (
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={formData.isActive}
                  onChange={handleSwitchChange}
                  name="isActive"
                  color="primary"
                />
              }
              label="Is Active?"
            />
          </Grid>
        )}

        <Grid item xs={12}>
          <Box display="flex" justifyContent="flex-end" gap={2}>
            <Button variant="outlined" onClick={onCancel} disabled={isBusy}>
              Cancel
            </Button>
            <Button
              variant="contained"
              type="submit"
              disabled={isBusy || !!Object.values(errors).find((e) => e)}
            >
              Submit
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DriverHistoryForm;